import { createFileRoute } from '@tanstack/react-router'
import BundleContainerMain from 'Bundle/containers/BundleContainerMain'
import { claimTypesEnum } from 'User/utils/claims'

import PrivateRoute from 'Common/components/router/PrivateRoute'
import { useAuth } from 'Common/utils/query/useAuth'

export const Route = createFileRoute('/bundle/_main')({
    component: BundleMain,
})

function BundleMain() {
    const auth = useAuth()

    return (
        <PrivateRoute auth={auth} restrictToClaims={[claimTypesEnum.enum.opus_work]}>
            <BundleContainerMain />
        </PrivateRoute>
    )
}
